import React from "react";
// components
import NavbarComponent from "./components/utilities/NavbarComponent";
import Footer from "./components/utilities/Footer";
import Router from "./Router";
import TwitterFeed from "./components/utilities/TwitterFeed";
import NavigateButtom from "./components/utilities/NavigateButtom";
function App() {
  return (
    <div className="position-relative">
      <NavbarComponent />
      {/* <NavigateButtom /> */}

      <Router />
      <Footer />
    </div>
  );
}

export default App;
